export default __webpack_public_path__ + "static/media/img-guide-gt-popup-5-de_de@2x.d952ce36.png";